import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Guid } from '@se/se.platform.base';

import { CpControlGrid } from '../../cp-configuration/utils/control-grid';
import { CpDialogService } from '../../cp-dialog-service';

interface DialogData {
    grid: CpControlGrid;
}

@Component({
    selector: 'cp-control-grid-modal',
    templateUrl: './custom-page-control-grid-modal.component.html',
    styleUrls: ['./custom-page-control-grid-modal.component.scss'],
    standalone: false
})
export class CustomPageControlGridModalComponent implements OnInit {
    public cardId!: string;
    public grid!: CpControlGrid;
    public form = new FormGroup({});

    constructor(private dialogService: CpDialogService) {}

    ngOnInit() {
        const { grid } = this.dialogService.param as DialogData;
        this.cardId = new Guid().toString();
        this.grid = grid;
    }
}
